exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".LootieWebflowAnimation__container{display:flex;cursor:pointer;align-self:center}", ""]);

// exports
